import React, { useState, useEffect, useRef, useCallback } from 'react';
import { MainComponent, Texts, Component1, Component2, InnerComponent, Component4, Component3, HiddenComponent, FooterPart, HeaderPart } from '../style.js';
import InputSelect from 'src/components/shared/Form/Select/index.js';
import { useTheme } from '@emotion/react';
import InputComponent from 'src/components/shared/Form/Input/index.js';
import theme, { palette, shadows } from 'src/config/theme.js';
import { alpha, Box, Typography, Avatar } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import DateTimePicker from 'src/components/App/DatePicker/index.js';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch } from 'react-redux';
import { postPatientRequest } from '../../../store/appActions.js';
import ButtonComponent from 'src/components/shared/Button/index.js';
import { ReactComponent as CloseIcon } from '../../../../../assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../../assets/images/add-square.svg';
import { getUserFromToken } from 'src/DecodeToken.js';
import dayjs from 'dayjs';
import { SaveButton } from '../style.js';
import toast from 'src/utils/toast';
import useResponsive from 'src/components/hooks/useResponsive.js';


const genderData = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: 'Other', value: 'other' },
]
const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('Enter First Name'),
    lastName: Yup.string().required('Enter Last Name'),
    contactNo: Yup.string().required('Enter Phone Number').matches(/^\d{10}$/, 'Contact number must be exactly 10 digits'),
    dateOfBirth: Yup.date().required('Select Your Date of Birth'),
    gender: Yup.string().required('Select Your gender'),
})



function AddPatient({ onClose, updatePatients }) {
    const { isMobile, isTablet } = useResponsive();
    const Width = isMobile || isTablet ? 18 : 24;
    const Height = isMobile || isTablet ? 18 : 24;

    const theme = useTheme();
    const dispatch = useDispatch();

    const handleSubmit = async (values, { resetForm }) => {
        const userId = getUserFromToken();
        console.log("my user id here", userId)
        if (!userId) {
            console('Failed to identify user. Please login again.', { variant: 'error' });
            return;
        }
        try {
            const fullName = [values.firstName, values.middleName, values.lastName].filter(Boolean).join(' ');
            const patientData = {
                fullName: fullName,
                firstName: values.firstName,
                middleName: values.middleName,
                lastName: values.lastName,
                contactNo: values.contactNo,
                waNo: values.waNo || values.contactNo,
                gender: values.gender,
                dateOfBirth: dayjs(values.dateOfBirth).format('YYYY-MM-DD'),
                users: [userId],
            }
            const response = await new Promise((resolve, reject) => {
                dispatch(postPatientRequest({ data: patientData, resolve, reject }));
            });
            console.log(`patient created successfully ${response}`);
            toast.success(response.message);

            updatePatients();
            resetForm();
            onClose();
        } catch (error) {
            console.log(error.message || 'Failed to add appointment', { variant: 'error' });
        }
    };
    return (
        <Formik
            initialValues={{
                firstName: '',
                middleName: '',
                lastName: '',
                dateOfBirth: null,
                gender: '',
                contactNo: '',
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched, isSubmitting }) => (
                <Form >
                    <>
                        <HeaderPart>
                            Add Patients
                            <CloseIcon
                                width={isMobile || isTablet ? 18 : 24}
                                height={isMobile || isTablet ? 18 : 24}
                                onClick={onClose}
                                style={{ cursor: 'pointer' }} />
                        </HeaderPart>
                        <MainComponent>

                                <Component2>
                                    <InnerComponent>
                                        <Texts>First Name</Texts>
                                        <InputComponent
                                            name="firstName"
                                            variant="outlined"
                                            placeholder="Enter First Name"
                                            fullWidth
                                            value={values.firstName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={touched.firstName && Boolean(errors.firstName)}
                                            helperText={touched.firstName && errors.firstName}
                                            sx={{
                                                backgroundColor: palette.gery.white,
                                                boxShadow: shadows[1],
                                                '& .MuiOutlinedInput-root': {
                                                    padding: '10px 0px',
                                                    borderRadius: '12px',
                                                    height: '52px',
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                },
                                                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                    ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                                },
                                            }}
                                        />
                                    </InnerComponent>
                                    <InnerComponent>
                                        <Texts>Middle Name</Texts>
                                        <InputComponent
                                            name="middleName"
                                            variant="outlined"
                                            placeholder="Enter Middle Name"
                                            fullWidth
                                            value={values.middleName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            sx={{
                                                backgroundColor: palette.gery.white,
                                                boxShadow: shadows[1],
                                                '& .MuiOutlinedInput-root': {
                                                    padding: '10px 0px',
                                                    borderRadius: '12px',
                                                    height: '52px',
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                },
                                                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                    ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                                },
                                            }}
                                        />
                                    </InnerComponent>
                                </Component2>

                                <Component2>
                                    <InnerComponent>
                                        <Texts>Last Name</Texts>
                                        <InputComponent
                                            name="lastName"
                                            variant="outlined"
                                            placeholder="Enter Last Name"
                                            fullWidth
                                            value={values.lastName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={touched.lastName && Boolean(errors.lastName)}
                                            helperText={touched.lastName && errors.lastName}
                                            sx={{
                                                backgroundColor: palette.gery.white,
                                                boxShadow: shadows[1],
                                                '& .MuiOutlinedInput-root': {
                                                    padding: '10px 0px',
                                                    borderRadius: '12px',
                                                    height: '52px',
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                },
                                                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                    ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                                },
                                            }}
                                        />
                                    </InnerComponent>
                                    <InnerComponent>
                                        <Texts>Phone Number</Texts>
                                        <InputComponent
                                            name="contactNo"
                                            variant="outlined"
                                            placeholder="Enter Number"
                                            fullWidth
                                            value={values.contactNo}
                                            onChange={(e) => {
                                                const onlyDigits = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                setFieldValue('contactNo', onlyDigits);
                                            }}
                                            onBlur={handleBlur}
                                            inputProps={{
                                                maxLength: 10,
                                                pattern: "^[0-9]{10}$",
                                            }}

                                            error={touched.contactNo && Boolean(errors.contactNo)}
                                            helperText={touched.contactNo && errors.contactNo}
                                            sx={{
                                                backgroundColor: palette.gery.white,
                                                boxShadow: shadows[1],
                                                '& .MuiOutlinedInput-root': {
                                                    padding: '10px 0px',
                                                    borderRadius: '12px',
                                                    height: '52px',
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                },
                                                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                    ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                                },
                                            }}
                                        />
                                    </InnerComponent>
                                </Component2>
                            <Component2>
                                <InnerComponent>
                                    <Texts>Gender</Texts>
                                    <InputSelect
                                        name="gender"
                                        showNone={false}
                                        options={genderData}
                                        value={values.gender}
                                        onChange={(value) => setFieldValue('gender', value)}
                                        onBlur={handleBlur}
                                        error={touched.gender && Boolean(errors.gender)}
                                        helperText={touched.gender && errors.gender}
                                        variant="outlined"
                                        placeholder="Select"
                                        sx={{
                                            // width: '200px',
                                            boxShadow: theme.shadows[1],
                                            '& .MuiOutlinedInput-root': {
                                                height: '52px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                // border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                                                borderRadius: '12px',
                                            },
                                        }}
                                    />

                                </InnerComponent>
                                <InnerComponent>
                                    <Texts>Date of Birth</Texts>
                                    <DateTimePicker
                                        name="dateOfBirth"
                                        value={values.dateOfBirth ? dayjs(values.dateOfBirth) : null}
                                        onChange={(val) => {
                                            setFieldValue('dateOfBirth', val);
                                        }}
                                        maxDate={dayjs().startOf('day')}
                                        readOnly={false}
                                        onBlur={handleBlur}
                                        error={touched.dateOfBirth && Boolean(errors.dateOfBirth)}
                                        helperText={touched.dateOfBirth && errors.dateOfBirth}
                                        type="date"
                                        sx={{
                                            height: "52px",
                                            borderRadius: '12px',
                                        }}
                                    />



                                </InnerComponent>
                            </Component2>
                        </MainComponent>
                        <FooterPart >
                            <ButtonComponent
                                variant="none"
                                startIcon={<CloseIcon
                                    width={Width}
                                    height={Height}
                                    sx={{ color: theme.palette.primary.main }} />}
                                onClick={onClose}
                            >
                                Cancel
                            </ButtonComponent>
                            <SaveButton
                                type="submit"
                                variant="outlined"
                                startIcon={<AddIcon
                                    width={Width}
                                    height={Height}
                                    sx={{ color: theme.palette.primary.main }} />}
                                disabled={isSubmitting}
                            >Save</SaveButton>
                        </FooterPart>
                    </>
                </Form>

            )}
        </Formik>
    )
}

export default AddPatient;



